import React from 'react';
import { CTAButton } from './CTAButton';
import { ProductShot } from './ProductShot';
export function Hero() {
  return <section className="border-b-4 border-cream-deep bg-white px-4 pb-5 pt-6 text-center sm:px-6" data-id="element-85" data-mp="ej4lxsz4c3dc">
      <h1 className="font-heading text-2xl font-extrabold uppercase leading-[1.08] text-navy sm:text-4xl" data-id="element-86" data-mp="9ll8gva8vumg">
        The Complete Ready-to-Use Activity System for Senior Care Professionals
      </h1>

      <p className="mx-auto mt-2.5 max-w-2xl text-[13px] font-semibold leading-snug text-graphite sm:text-base" data-id="element-87" data-mp="12860lxyjoar2">
        Stop spending hours searching for new ideas, planning activities from
        scratch, and wondering what you’re going to organize next.
      </p>

      <p className="mx-auto mt-2 max-w-2xl text-[13px] font-medium leading-snug text-graphite/90 sm:text-base" data-id="element-88" data-mp="ncq0bb7dfim8">
        Get one complete professional system filled with ready-to-use cognitive,
        social, creative, recreational and gentle movement activities —{' '}
        <strong className="font-bold text-navy" data-id="element-89" data-mp="384s4wnk2qj2j">
          organized and ready when you need them.
        </strong>
      </p>

      <ProductShot size="lg" className="my-4" data-id="element-90" data-mp="3o85b7b3xi14k" />

      <div className="mx-auto max-w-md" data-id="element-91" data-mp="3o6u8lem7yzf1">
        <CTAButton data-id="element-92" data-mp="39al9qe68qo35">👥 Yes! I want the complete system</CTAButton>
      </div>

      <p className="mt-2.5 text-[12px] font-bold text-navy sm:text-sm" data-id="element-93" data-mp="39cpc2rohrf1b">
        🛡️ 14-Day Money-Back Guarantee — Zero Risk
      </p>
    </section>;
}